import { useEffect, useState } from "react";
import { useTenantStore } from "@/store/tenant.store.js";
import { authIntegration } from "@/lib/api/client.js";

const DEFAULT_FLAGS = { Document: false, Asset: false, Risk: false };

/**
 * Entity types where the current user has at least one party assignment (for sidebar / gates).
 */
export function usePartyAssignmentFlags() {
    const selectedTenantId = useTenantStore((s) => s.selectedTenantId);
    const [flags, setFlags] = useState(DEFAULT_FLAGS);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!selectedTenantId) {
            setFlags(DEFAULT_FLAGS);
            setIsLoading(false);
            return;
        }
        let cancelled = false;
        setIsLoading(true);
        (async () => {
            try {
                const result = await authIntegration.getPartyAssignmentFlags();
                if (cancelled) return;
                if (result?.success && result.data && typeof result.data === "object") {
                    setFlags({
                        Document: Boolean(result.data.Document),
                        Asset: Boolean(result.data.Asset),
                        Risk: Boolean(result.data.Risk),
                    });
                } else {
                    setFlags(DEFAULT_FLAGS);
                }
            } catch {
                if (!cancelled) setFlags(DEFAULT_FLAGS);
            } finally {
                if (!cancelled) setIsLoading(false);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [selectedTenantId]);

    return { ...flags, isLoading };
}
